/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

import api from './api';

/**
 * Baseline capture configuration (#797) — mirrors the backend `BaselineConfigDto`.
 * A first-class, single-global config object edited from the /config page's
 * "Baseline Capture" card.
 */
export interface BaselineConfig {
  /** Master switch; when false no session is sampled for baseline. */
  enabled?: boolean;
  /** Percentage of sessions to sample for baseline (0–100), deterministic per-session. */
  sampleRatePercent?: number;
  /** Request strategy id/name used for baseline pass-through calls. */
  reqStrategyId?: string;
  /** Optional round index of the baseline strategy to use (else the immediate/tagged round). */
  roundIndex?: number;
}

export const baselineService = {
  async getBaselineConfig(): Promise<BaselineConfig> {
    const { data } = await api.get<BaselineConfig>('/api/baseline-config');
    return data;
  },

  async saveBaselineConfig(config: BaselineConfig): Promise<void> {
    await api.post('/api/baseline-config', config);
  },
};
